import { Button, styled } from '@mui/material';

export const UploadButton = styled(Button)({
  borderRadius: '24px',
  padding: '8px 24px',
  backgroundColor: '#B3EC49',
  color: 'black',
  '&:hover': {
    backgroundColor: 'rgba(179, 236, 73, 0.8)',
  },
});
